module.exports = __webpack_public_path__ + "static/media/team23.99f6a2f8.jpeg";